import {inject, Injectable,signal} from '@angular/core';
import {Client} from '../../../api/client';
import {AuthService} from '../../services/authentication/auth.service.service';

@Injectable({
  providedIn: 'root'
})
export class BasketUiServiceService {
  public items: any
  countBasket = signal<number>(0);
  private client = inject(Client);
  auth = inject(AuthService)

constructor() {
  this.init()
}

  setItems(item: any) {
    this.items = item;
  }
  init(){
    if (this.auth.isAuthenticated()) {
     this.initBasket()
    }
  }

  initBasket(): void {
    this.client.basketNew_GetCount().subscribe((res: number) => {
        this.countBasket.set(res);
      });
  }
}
